import Link from "next/link";
import React from "react";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  className?: string;
  className2?: string;
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  className = "",
  className2 = "",
}) => {
  if (!items || items.length === 0) return null;
  const lastItem = (label: string) => (
    <span className={`text-subtitle-2 ${className2} font-regular`}>
      {label}
    </span>
  );
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="inline-flex items-center gap-2 text-gray-300">
        {items?.map((item, index) => {
          const isLast = items.length > 1 ? index === items.length - 1 : false;

          return (
            <li key={index} className="inline-flex items-center gap-2 ">
              {!isLast ? (
                <>
                  {item.href ? (
                    <Link
                      href={item.href ?? "/"}
                      className={`hover:underline ${className2} hover:text-primary-text-white text-subtitle-2 font-regular cursor-pointer`}
                    >
                      {item.label}
                    </Link>
                  ) : (
                    lastItem(item.label)
                  )}
                  {!!items[index + 1] && (
                    <span className={`${className2} `}>/</span>
                  )}
                </>
              ) : (
                lastItem(item.label)
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
